import React, {useEffect} from "react";
import {Col, Container, Row} from "react-bs4grid";
import {Link} from "react-router-dom";

import useAppState from "../../common/StateMachine/useAppState";
import JobCard from "./JobCard";

import "./jobs.scss";
import {useTranslation} from "react-i18next";

const MyJobs = ({history}) => {
    const accountState = useAppState("account");
    const jobsState = useAppState("jobs");
    const {t} = useTranslation();

    useEffect(() => {
        if(accountState.hasRole("Processor")) {
            history.push("/processorQualitycheck");
        }
        jobsState.getJobs(null, true, null);
    }, []);

    const completed =
        jobsState.state.jobs.data &&
        jobsState.state.jobs.data.filter(job => {
            return (
                job.userCommitment.totalAmountCollected >=
                job.userCommitment.totalAmountCommitted
            );
        });

    const inProgress =
        jobsState.state.jobs.data &&
        jobsState.state.jobs.data.filter(job => {
            return (
                job.userCommitment.totalAmountCollected <
                job.userCommitment.totalAmountCommitted
            );
        });

    return (
        <Container fluid className="jobs-list-container pb-64">
            {
                <Row
                    className="jobs-list pt-8 pb-8"
                    justifyContent="center"
                    alignItems="center"
                >
                    <Col
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center"
                        }}
                        sm={{
                            size: 12
                        }}
                        md={{
                            size: 12
                        }}>
                    </Col>
                </Row>
            }
            <Row
                className="jobs-list pb-8"
                justifyContent="center"
                alignItems="center"
                style={{flexDirection: "column"}}
            >
                <div className="job-column">
                    {inProgress &&
                    inProgress.length > 0 &&
                    inProgress.map(job => {
                        return (
                            <Col
                                className="job-column"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                }}
                                key={job.id}
                                sm={{
                                    size: 12
                                }}
                                md={{
                                    size: 12
                                }}
                            >
                                <JobCard id={job.id} {...job} />
                            </Col>
                        );
                    })}
                    {!completed && !inProgress && (
                        <Col>
                            <div className="no-jobs-placeholder pt-64">
                                <img
                                    src="/empty-no-plastic-recovered.png"
                                    alt="no plastic recovered"
                                />
                                <h3>....</h3>
                                <p>
                                    <Link to="/jobs/browse-new">{t("browseNew")}</Link>
                                </p>
                            </div>
                        </Col>
                    )}
                </div>
            </Row>
            <Row
                className="jobs-list pt-8 pb-8"
                justifyContent="center"
                alignItems="center"
            >
                <Col
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center"
                    }}
                    sm={{
                        size: 12
                    }}
                    md={{
                        size: 12
                    }}
                >
                    <div style={{width: "433px", textAlign: "left"}}>
                        {completed && completed.length > 0 && (
                            <h4 style={{marginBottom: "4px"}}>
                                {t("fulfilled")} ({completed.length})
                            </h4>
                        )}
                    </div>
                </Col>
            </Row>
            <Row
                className="jobs-list pb-16"
                justifyContent="center"
                alignItems="center"
                style={{flexDirection: "column"}}
            >
                <div className="job-column">
                    {completed &&
                    completed.length > 0 &&
                    completed.map(job => {
                        return (
                            <Col
                                className="job-column"
                                style={{
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                                key={job.id}
                                sm={{
                                    size: 12
                                }}
                                md={{
                                    size: 12
                                }}
                            >
                                <JobCard id={job.id} disabled={false} {...job} />
                            </Col>
                        );
                    })}
                </div>
            </Row>
        </Container>
    );
};

export default MyJobs;
